<template>
  <span>
    <a-tag class="is_tag" @click="actionCb(instance.list[scope.scope.useStatus].cb, scope.scope)" :color="instance.list[scope.scope.useStatus].color">
       {{instance.list[scope.scope.useStatus].userName}}
    </a-tag>
  </span>
</template>

<script>
export default {
  props: {
    instance: Object,
    scope: Object // text, index, scope
  },
  data() {
    return {
    }
  },
  computed: {
    status () {
      const { status, useStatus } = this.scope.scope
      return useStatus || status
    }
  },
  methods: {
    actionCb(cb, row) {
      this.$emit('actionClick', { cb, row })
    }
  }
}
</script>
<style lang="scss" scoped>
.is_tag{
  cursor: pointer;
}
</style>